module.exports = __webpack_public_path__ + "img/ANA BEATRIZ.5f2fd30b.jpeg";